/**
 * Contains configurations for CTAs throughout the site.
 */

import { appId } from '@/config'
import AppStore from './appStore'

const appStore = new AppStore({ appId })

export const jumbotron = {
  divider: false,
  identifier: 'com.ultimatezmanim.cta.jumbotron',
  leadingTitle: 'Features',
  leadingUrl: undefined,
  leadingRoute: undefined,
  leadingColor: '#fff',
  leadingBackgroundColor: '#000',
  leadingShadow: false,
  trailingTitle: 'Download',
  trailingUrl: appStore.link,
  trailingRoute: undefined,
  trailingColor: '#fff',
  trailingBackgroundColor: '#ff8511',
  trailingShadow: true
}

export const interstitialFAQDownload = {
  identifier: 'com.ultimatezmanim.cta.interstitial',
  leadingTitle: 'FAQs',
  leadingUrl: undefined,
  leadingRoute: undefined,
  leadingColor: '#000',
  leadingBackgroundColor: '#fff',
  leadingShadow: true,
  trailingTitle: 'Download',
  trailingUrl: appStore.link,
  trailingRoute: undefined,
  trailingColor: '#fff',
  trailingBackgroundColor: '#ff8511',
  trailingShadow: true,
  comment: undefined
}

export const interstitialFAQDownloadItsFree = {
  identifier: 'com.ultimatezmanim.cta.interstitial',
  leadingTitle: 'FAQs',
  leadingUrl: undefined,
  leadingRoute: undefined,
  leadingColor: '#000',
  leadingBackgroundColor: '#fff',
  leadingShadow: true,
  trailingTitle: 'Download',
  trailingUrl: appStore.link,
  trailingRoute: undefined,
  trailingColor: '#fff',
  trailingBackgroundColor: '#ff8511',
  trailingShadow: true,
  comment: "(It's free!)",
  divider: false
}

export const interstitialFAQDownloadComparison = {
  identifier: 'com.ultimatezmanim.cta.interstitial',
  leadingTitle: 'Comparison Chart',
  leadingUrl: undefined,
  leadingRoute: undefined,
  leadingColor: '#000',
  leadingBackgroundColor: '#fff',
  leadingShadow: true,
  trailingTitle: 'Download',
  trailingUrl: appStore.link,
  trailingRoute: undefined,
  trailingColor: '#fff',
  trailingBackgroundColor: '#ff8511',
  trailingShadow: true,
  comment: "(It's still free!)",
  divider: false
}

export const interstitialFooter = {
  identifier: 'com.ultimatezmanim.cta.interstitial',
  leadingTitle: 'Download',
  leadingUrl: appStore.link,
  leadingRoute: undefined,
  leadingColor: '#fff',
  leadingBackgroundColor: '#ff8511',
  leadingShadow: true,
  trailingTitle: 'Contact Us',
  trailingUrl: undefined,
  trailingRoute: undefined,
  trailingColor: '#fff',
  trailingBackgroundColor: '#332924',
  trailingShadow: false,
  comment: undefined,
  divider: false,
  leadingCSS: {
    color: '#fff',
    backgroundColor: '#ff8511',
    margin: '0 1.53rem',
    width: '14.38rem'
  }
}
